module.exports = "/_next/static/images/icon_youtube2-595478576f58a0c14db958d5ec762aeb.svg";